{
  "order_button": "Commander via WhatsApp",
  "order_button_short": "WhatsApp",
  "support_button": "Aide WhatsApp",
  "confirmation": {
    "title": "Confirmer via WhatsApp",
    "subtitle": "Envoyez votre commande directement sur WhatsApp pour confirmation rapide",
    "send": "Envoyer sur WhatsApp",
    "already_confirmed": "J'ai déjà confirmé",
    "preview_title": "Aperçu du message"
  },
  "messages": {
    "order_greeting": "Bonjour, je souhaite commander :",
    "order_total": "Total",
    "order_delivery": "Livraison",
    "order_payment": "Paiement",
    "order_thanks": "Merci !",
    "support_greeting": "Bonjour, j'ai besoin d'aide concernant",
    "tracking_request": "Bonjour, je voudrais suivre ma commande"
  },
  "new_order_title": "Nouvelle commande Djayma"
}
